import React, { Suspense, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { DataProvider } from "./Components/DataContext";
import { AlertModalProvider } from "./Context/AlertModalContext";
import Toastify from "./utils/tostfy";
import SessionReloginModalGate from "./Components/SessionReloginModalGate";
import { listenForForegroundMessages } from "./utils/firebaseMessaging";

import ResetPassword from "./Pages/ResetPassword/ResetPassword";

const Home = React.lazy(() => import("./Pages/Home/Home"));
const Login = React.lazy(() => import("./Pages/Login/Login"));
const Faq = React.lazy(() => import("./Pages/Faq/Faq"));
const Privacypolicy = React.lazy(() => import("./Pages/Privacypolicy/Privacypolicy"));
const Signup = React.lazy(() => import("./Pages/Signup/Signup"));
const Profile = React.lazy(() => import("./Pages/Profile/Profile"));
const Aboutus = React.lazy(() => import("./Pages/Aboutus/Aboutus"));
const Contact = React.lazy(() => import("./Pages/Contact/Contact"));
const Checklist = React.lazy(() => import("./Pages/Checklist/Checklist"));
const Settings = React.lazy(() => import("./Pages/Settings/Settings"));
const OTPVerification = React.lazy(() => import("./Pages/OTPVerification/OTPVerification"));
const Forgotpassword = React.lazy(() => import("./Pages/Forgotpassword/Forgotpassword"));
const Customizewebsite = React.lazy(() => import("./Pages/Customizewebsite/Customizewebsite"));
const Notifications = React.lazy(() => import("./Pages/Notifications/Notifications"));
const Termsconditions = React.lazy(() => import("./Pages/Termsconditions/Termsconditions"));
const Refundreturnpolicy = React.lazy(() => import("./Pages/Refundreturnpolicy/Refundreturnpolicy"));
const RentalPolicy = React.lazy(() => import("./Pages/RentalPolicy/RentalPolicy"));
const CancellationPolicy = React.lazy(() => import("./Pages/CancellationPolicy/CancellationPolicy"));
const AllServices = React.lazy(() => import("./Pages/AllServices/AllServices"));
const AllVenues = React.lazy(() => import("./Pages/AllVenues/AllVenues"));
const AllLuxVenues = React.lazy(() => import("./Pages/AllLuxVenues/AllLuxVenues"));
const AllLuxVenuesTermAndcondition = React.lazy(() => import("./Pages/AllLuxVenues/TermAndCondition"));
const VenueDetails = React.lazy(() => import('./../src/Pages/AllLuxVenues/VenueDetail'))

const AllDecor = React.lazy(() => import("./Pages/AllDecor/AllDecor"));
const DecorNCR = React.lazy(() => import("./Pages/AllDecor/DecorNCR"));
const DecorDetails = React.lazy(() => import('./../src/Pages/AllDecor/DecorDetail'))

const CatInner = React.lazy(() => import("./Pages/Caterning/innercat"));
const CustomOptions = React.lazy(() => import("./Pages/Caterning/CustomOptions"));
const CatNCR = React.lazy(() => import('./../src/Pages/Caterning/cateringNCR'))
const CatDetails = React.lazy(() => import('./../src/Pages/Caterning/CaterningDetails'))
const BuyItem = React.lazy(() => import('./../src/Pages/Caterning/BuyItem'))
const BasicMenuPresets = React.lazy(() => import("./Pages/Caterning/BasicMenuPresets"));
const PackageTierList = React.lazy(() => import("./Pages/AllPackages/PackageTierList"));
const PackageDetail = React.lazy(() => import("./Pages/AllPackages/PackageDetail"));
const PackageInquiryDetail = React.lazy(() => import("./Pages/AllPackages/PackageInquiryDetail"));
const PackageBookingDetail = React.lazy(() => import("./Pages/AllPackages/PackageBookingDetail"));

const AllEnt = React.lazy(() => import("./Pages/AllEntertianment/AllEnt"));
const EntNCR = React.lazy(() => import("./Pages/AllEntertianment/EntNCR"));
const EntDetails = React.lazy(() => import('./../src/Pages/AllEntertianment/EntDetail'))

const AllClothes = React.lazy(() => import("./Pages/Clothing/AllClothes"));
const ClothesNCR = React.lazy(() => import("./Pages/Clothing/ClothesNCR"));
const ClothesDetails = React.lazy(() => import('./../src/Pages/Clothing/ClothesDetail'))

const AllVideo = React.lazy(() => import("./Pages/VideoGraphy/AllVideo"));
const VideoNCR = React.lazy(() => import("./Pages/VideoGraphy/Video"));
const VideoDetails = React.lazy(() => import('./../src/Pages/VideoGraphy/VideoDetail'))

const AllGroom = React.lazy(() => import("./Pages/Grooming/Grooming"));
const GroomNCR = React.lazy(() => import("./Pages/Grooming/GroomingNCR"));
const GroomDetails = React.lazy(() => import('./../src/Pages/Grooming/GroomingDetails'))

const AllBeauty = React.lazy(() => import("./Pages/Beauty And Wellness/Beauty"));
const BeautyNCR = React.lazy(() => import("./Pages/Beauty And Wellness/BeautyNCR"));
const BeautyDetails = React.lazy(() => import('./../src/Pages/Beauty And Wellness/BeautyDetails'))

const AllPandit = React.lazy(() => import("./Pages/Pandit/Pandit"));
const PanditNCR = React.lazy(() => import("./Pages/Pandit/PanditNCR"));
const PanditDetails = React.lazy(() => import('./../src/Pages/Pandit/PanditDetails'))

const AllRecycle = React.lazy(() => import("./Pages/Recycle/Recycle"));
const RecycleNCR = React.lazy(() => import("./Pages/Recycle/RecycleNCR"));
const RecycleDetails = React.lazy(() => import('./../src/Pages/Recycle/RecycleDetails'))

const AllManagement = React.lazy(() => import("./Pages/Management Services/AllManagement"));
const ManagementNCR = React.lazy(() => import("./Pages/Management Services/ManagementNCR"));
const ManagementDetails = React.lazy(() => import('./../src/Pages/Management Services/ManagementDetails'))

const AllInvitation = React.lazy(() => import("./Pages/Invitation & Gifts/AllInvitation"));
const InvitationNCR = React.lazy(() => import("./Pages/Invitation & Gifts/InvitationNCR"));
const InvitationDetails = React.lazy(() => import('./../src/Pages/Invitation & Gifts/InvitationDetails'))

const MyBooking_inquires = React.lazy(() => import('./../src/Pages/Booking_Inquiries/Booking_Inquiries'))
const MyBooking_orders = React.lazy(() => import('./../src/Pages/Booking_Orders/Booking_Orders'))
const MyBooking_View = React.lazy(() => import('./../src/Pages/Booking_Orders/BookingOrderView'))
const CateringBooking_View = React.lazy(() => import('./../src/Pages/Booking_Orders/CateringBookingOrderView'))
const ProductOrderDetailPage = React.lazy(() => import('./../src/Pages/Booking_Orders/ProductOrderDetailView'))
const ProductRentalDetailPage = React.lazy(() => import('./../src/Pages/Booking_Orders/ProductRentalDetailView'))

const AllShop = React.lazy(() => import('./../src/Pages/AllShop/AllShop'))
const ShopCategory = React.lazy(() => import('./../src/Pages/AllShop/ShopCategory'))
const ShopDetails = React.lazy(() => import('./../src/Pages/AllShop/ShopDetails'))

const AllRent = React.lazy(() => import('./../src/Pages/AllRent/AllRent'))
const RentCategory = React.lazy(() => import('./../src/Pages/AllRent/RentCategoryDetail'))
const RentDetails = React.lazy(() => import('./../src/Pages/AllRent/RentDetails'))

const FoodItems = React.lazy(() => import("./Pages/Caterning/foodItems"));
const CateringCartSummary = React.lazy(() => import("./Pages/Caterning/CateringCartSummary"));
const CateringSampleView = React.lazy(() => import("./Pages/Caterning/CateringSampleView"));
const Cart = React.lazy(() => import("./Pages/Cart/Cart"));
const ShopCheckout = React.lazy(() => import("./Pages/Cart/ShopCheckout"));
const Wishlist = React.lazy(() => import("./Pages/Wishlist/Wishlist"));

/** `/caterning` → basic presets (replaces old Caterning landing page). */
function CateringRootRedirect() {
  return <Navigate to="/caterning/presets" replace />;
}

function App() {
  // const isSessionExpired = () => {
  //   const lastActivityTime = localStorage.getItem("lastActivityTime");
  //   if (lastActivityTime) {
  //     return Date.now() - parseInt(lastActivityTime, 10) > 60 * 60 * 1000; // 1 hour in milliseconds
  //   }
  //   return true;
  // };
  // useEffect(() => {
  //   if (isSessionExpired()) {
  //     localStorage.clear();
  //   }
  // }, []);
  useEffect(() => {
    let unsubscribe = () => {};

    const subscribeToForegroundFcm = async () => {
      unsubscribe = await listenForForegroundMessages((payload) => {
        const title =
          payload?.notification?.title || payload?.data?.title || "Event Management";
        const body = payload?.notification?.body || payload?.data?.body || "";
        const message = body ? `${title}: ${body}` : title;
        console.log("FCM notification received:", {
          title,
          body,
          payload,
        });
        toast.info(message, { autoClose: 9000 });
      });
    };

    subscribeToForegroundFcm();

    return () => {
      unsubscribe();
    };
  }, []);

  const PrivateOutlet = () => {
    const loginSuccess = useSelector((state) => state.loginInfo.userInformation);
    const storedStatus = localStorage.getItem("status");
    let isLoggedIn = false;
    try {
      isLoggedIn =
        (loginSuccess?.code === 200) ||
        (storedStatus && JSON.parse(storedStatus) === 200);
    } catch (error) {
      console.error("Error parsing localStorage data:", error);
    }
    return isLoggedIn ? <Outlet /> : <Navigate to="/" replace />;
  };
  return (
    <DataProvider>
      <AlertModalProvider>
        <Toastify />
        <SessionReloginModalGate />
        <Router>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>

            <Route path="/" element={<Home />}></Route>
            <Route path="/home" element={<Home />}></Route>

            <Route path="/allservices" element={<AllServices />}></Route>

            <Route path="/allveneus" element={<AllVenues />}></Route>
            <Route path="/allluxveneus" element={<AllLuxVenues />}></Route>
            <Route path="/allluxveneus/term-and-condition" element={<AllLuxVenuesTermAndcondition />}></Route>
            <Route path="/allluxveneus/Details" element={<VenueDetails />}></Route>

            <Route path="/alldecor" element={<AllDecor />}></Route>
            <Route path="/alldecor/NCR" element={<DecorNCR />}></Route>
            <Route path="/alldecor/Details" element={<DecorDetails />}></Route>

            <Route path="/alldecor" element={<AllDecor />}></Route>
            <Route path="/alldecor/NCR" element={<DecorNCR />}></Route>
            <Route path="/alldecor/Details" element={<DecorDetails />}></Route>

            <Route path="/allEnt" element={<AllEnt />}></Route>
            <Route path="/allEnt/NCR" element={<EntNCR />}></Route>
            <Route path="/allEnt/Details" element={<EntDetails />}></Route>

            <Route path="/allClothes" element={<AllClothes />}></Route>
            <Route path="/allClothes/NCR" element={<ClothesNCR />}></Route>
            <Route path="/allClothes/Details" element={<ClothesDetails />}></Route>

            <Route path="/caterning" element={<CateringRootRedirect />}></Route>
            <Route path="/caterning/inner" element={<CatInner />}></Route>
            <Route path="/caterning/customOptions" element={<CustomOptions />}></Route>
            <Route path="/caterning/presets" element={<BasicMenuPresets />} ></Route>
            <Route path="/caterning/catringNcr/buyitem" element={<BuyItem />}></Route>
            <Route path="/caterning/catringNcr" element={<CatNCR />}></Route>
            <Route path="/caterning/catringNcr/Details" element={<CatDetails />}></Route>

            <Route path="/packages" element={<PackageTierList />}></Route>
            <Route path="/packages/list" element={<PackageTierList />}></Route>
            <Route path="/packages/details/:id" element={<PackageDetail />}></Route>
            <Route path="/packages/inquiry/:id" element={<PackageInquiryDetail />}></Route>
            <Route path="/packages/booking/:id" element={<PackageBookingDetail />}></Route>

            <Route path="/allvedio" element={<AllVideo />}></Route>
            <Route path="/allvedio/NCR" element={<VideoNCR />}></Route>
            <Route path="/allVideo/Details" element={<VideoDetails />}></Route>

            <Route path="/allGroom" element={<AllGroom />}></Route>
            <Route path="/allGroom/NCR" element={<GroomNCR />}></Route>
            <Route path="/allGroom/Details" element={<GroomDetails />}></Route>

            <Route path="/allBeauty" element={<AllBeauty />}></Route>
            <Route path="/allBeauty/NCR" element={<BeautyNCR />}></Route>
            <Route path="/allBeauty/Details" element={<BeautyDetails />}></Route>
            <Route path="/caterning/foodItems" element={<FoodItems />}></Route>
            <Route path="/caterning/cart-summary" element={<CateringCartSummary />}></Route>
            <Route path="/caterning/view-sample" element={<CateringSampleView />}></Route>
            <Route path="/allPandit" element={<AllPandit />}></Route>
            <Route path="/allPandit/NCR" element={<PanditNCR />}></Route>
            <Route path="/allPandit/Details" element={<PanditDetails />}></Route>

            <Route path="/allRecycle" element={<AllRecycle />}></Route>
            <Route path="/allRecycle/NCR" element={<RecycleNCR />}></Route>
            <Route path="/allRecycle/Details" element={<RecycleDetails />}></Route>

            <Route path="/allManagement" element={<AllManagement />}></Route>
            <Route path="/allManagement/NCR" element={<ManagementNCR />}></Route>
            <Route path="/allManagement/Details" element={<ManagementDetails />}></Route>

            <Route path="/allInvitation" element={<AllInvitation />}></Route>
            <Route path="/allInvitation/NCR" element={<InvitationNCR />}></Route>
            <Route path="/allInvitation/Details" element={<InvitationDetails />}></Route>

            <Route path="/Mybooking_inquiries" element={<MyBooking_inquires />}></Route>

            <Route path="/Mybooking_orders" element={<MyBooking_orders />}></Route>
            <Route path="/Mybooking_orders/MyOrderView" element={<MyBooking_View />}></Route>
            <Route path="/Mybooking_orders/CateringOrderView" element={<CateringBooking_View />}></Route>
            <Route path="/Mybooking_orders/ProductOrderDetail" element={<ProductOrderDetailPage />}></Route>
            <Route path="/Mybooking_orders/ProductRentalDetail" element={<ProductRentalDetailPage />}></Route>

            <Route path="/AllShop" element={<AllShop />}></Route>
            <Route path="/ShopCategory" element={<ShopCategory />}></Route>
            <Route path="/ShopCategory/ShopDetails" element={<ShopDetails />}></Route>

            <Route path="/AllRent" element={<AllRent />}></Route>
            <Route path="/AllRent/Details" element={<RentCategory />}></Route>
            <Route path="/AllRent/Details/catdetails" element={<RentDetails />}></Route>

            <Route path="/about" element={<Aboutus />}></Route>
            <Route path="/contact" element={<Contact />}></Route>
            <Route path="/settings" element={<Settings />}></Route>
            <Route path="/profile" element={<Profile />}></Route>
            <Route path="/faq" element={<Faq />}></Route>
            <Route path="/privacy-policy" element={<Privacypolicy />}></Route>
            <Route path="/login" element={<Login />}></Route>
            <Route path="/signup" element={<Signup />}></Route>
            <Route path="/checklist" element={<Checklist />}></Route>
            <Route path="/forgetpassword" element={<Forgotpassword />}></Route>
            <Route path="/otpverification" element={<OTPVerification />}></Route>
            <Route path="/ResetPassword" element={<ResetPassword />}></Route>
            <Route path="/notifications" element={<Notifications />}></Route>
            <Route path="/refund-return-policy" element={<Refundreturnpolicy />}></Route>
            <Route path="/rental-policy" element={<RentalPolicy />}></Route>
            <Route path="/cancellation-policy" element={<CancellationPolicy />}></Route>
            <Route path="/terms-conditions" element={<Termsconditions />}></Route>
            <Route path="/customize-website" element={<Customizewebsite />}></Route>
            <Route path="/cart" element={<Cart />}></Route>
            <Route path="/shop/checkout" element={<ShopCheckout />}></Route>
            <Route path="/wishlist" element={<Wishlist />}></Route>
          </Routes>
        </Suspense>
      </Router>
      </AlertModalProvider>
    </DataProvider>
  );
}

export default App;
